import { render, staticRenderFns } from "./ResidentialTemplate.vue?vue&type=template&id=394c8bd4"
import script from "./ResidentialTemplate.vue?vue&type=script&lang=js"
export * from "./ResidentialTemplate.vue?vue&type=script&lang=js"
import style0 from "./ResidentialTemplate.vue?vue&type=style&index=0&id=394c8bd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports